<template>
    <toolbar-option type="stacked">
        <template slot="primary">
            <color-picker :value="color" @input="onInput" />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option';

export default {
    name: 'background-image-overlay',

    mixins: [baseOption],

    data() {
        return {
            displayName: 'Image Overlay Color',
            color: '',
        };
    },

    methods: {
        // updates selected color in editor as well as element data:
        onInput(newColor) {
            this.color = newColor;
            this.selectedElements[0].setElementData('background-overlay', this.color);
            this.onOptionChange(newColor);
        },

        // sets default color:
        onSelectedElement() {
            const backgroundOverlay = this.selectedElements[0].getElementData('background-overlay');
            this.color = backgroundOverlay || 'transparent';
        },
    },
};
</script>
